export var ENTITY = "application";
export var REDUCER_KEY = "APPLICATIONS_V2";
export var BASE_PATH_ENTITY = "applications";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
};
